import { render, staticRenderFns } from "./ServiceOrderForAdm.vue?vue&type=template&id=580f268c&scoped=true&"
import script from "./ServiceOrderForAdm.vue?vue&type=script&lang=js&"
export * from "./ServiceOrderForAdm.vue?vue&type=script&lang=js&"
import style0 from "./ServiceOrderForAdm.vue?vue&type=style&index=0&id=580f268c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580f268c",
  null
  
)

export default component.exports